import { render, staticRenderFns } from "./AddScopeBase.vue?vue&type=template&id=16ab8bf5&scoped=true&"
import script from "./AddScopeBase.vue?vue&type=script&lang=ts&"
export * from "./AddScopeBase.vue?vue&type=script&lang=ts&"
import style0 from "./AddScopeBase.vue?vue&type=style&index=0&id=16ab8bf5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ab8bf5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VSelect})
